import { useState, useMemo, useEffect } from "react";
import styled from "@emotion/styled";
import { useFormData } from "../../../contexts/FormData";

import { useFormikContext } from "formik";

import { useQuery } from "@tanstack/react-query";

import { getInventoryByVendor } from "../apiService";

import { BasicFlex, ScrollableContainer, InputLabel } from "../../../utils/Common";

import SimpleChip from "../../../utils/utilities/SimpleChip";

import { IconButton } from "@mui/material";

import CloseRounded from '@mui/icons-material/CloseRounded';
import TaskAltRoundedIcon from '@mui/icons-material/TaskAltRounded';

import SearchInput from "../../../utils/utilities/SearchInput";

const Container = styled(ScrollableContainer)`
  width: 90rem;
  margin-bottom: 6rem;

  input {
    cursor: pointer;
  }
`;

const Row = styled(BasicFlex)`
  gap: 1rem;
  /* margin-bottom: 1rem; */
  border-bottom: 1px solid ${props => props.theme.colors.border};
`;

const RowItem = styled.div`
  padding: 1.2rem;
`

const RowItemSelect = styled(RowItem)`

`

const WigLine = styled(BasicFlex)`
  border: 1px solid ${props => props.theme.colors.success};
  border-radius: 3px;
  padding: .5rem 1rem;
  gap: 2rem;
`;

const WigLineInfo = styled(BasicFlex)`
  flex-grow: 1;
  justify-content: flex-start;
`;

const SelectedTagsContainer = styled(BasicFlex)`
  flex-wrap: wrap;
  gap: 1rem;
  padding: 1rem 0;
  min-height: 4rem; // Prevents layout jump when empty
`;

const SearchContainer = styled.div`
  width: 65%;
  margin: 1rem 0;
`


const ReturnWigs = () => {
  const { values } = useFormikContext() || {};

  const { formValues, setFormValues } = useFormData() || {};

  const [localList, setLocalList] = useState([]);

  // 1. Source of truth is an array in form values
  const selectedWigs = formValues?.wigs || [];

  // 2. Create a memoized Set of IDs for instant lookups during render
  // This ensures the inventory list doesn't lag when checking/unchecking
  const selectedIds = useMemo(() => 
    new Set(selectedWigs.map(wig => wig.wig_id)), 
    [selectedWigs]
  );

  const searchLocalList = (e) => {
    let wigId = e.target.value;
    let nl = inventory?.filter(wig => wig?.wig_id?.toLowerCase()?.includes(wigId?.toLowerCase())) || [];
    setLocalList(nl);
  }

  const { data: inventory } = useQuery({
    queryKey: ["inventory", values?.vendor_id],
    queryFn: () => getInventoryByVendor(values?.vendor_id, "stock"),
    enabled: !!values?.vendor_id,
  });

  const handleToggle = (wig) => {
    const isSelected = selectedIds.has(wig.wig_id);
    
    if (isSelected) {
      // Filter out the item to remove it
      const nextValue = selectedWigs.filter(item => item.wig_id !== wig.wig_id);
      setFormValues(ofv => ({ ...ofv, wigs: nextValue })); 
    } else {
      // Spread into a new array to add it
      setFormValues(ofv => ({ ...ofv, wigs: [...ofv.wigs, wig] }));
    }
  };

  // this is just for edit, when loading the form
  useEffect(() => {
    if (values?.wigs?.length) {
      console.log(values?.wigs, "values?.wigs");
      setFormValues(ofv => ({ ...ofv, wigs: values?.wigs }));
    }
  }, [values?.wigs])


  useEffect(() => {
    setLocalList(inventory);
  }, [inventory]);

  // if vendor_id changes reset list - only when not in edit mode
  useEffect(() => {
    if (!values?.wigs?.length) {
      setFormValues(ofv => ({ ...ofv, wigs: [] }));
    }
  }, [values?.vendor_id]);

  return (
    <BasicFlex dir="column">
      <InputLabel>Select Wigs to Return</InputLabel>
      <SearchContainer>
        <SearchInput onChange={searchLocalList} fieldsToSearch={["Wig ID"]} />
      </SearchContainer>
      <Container>
        {localList?.map(el => {
          const isChecked = selectedIds.has(el.wig_id);
          return (
          <Row key={el.inventory_id}>
            <RowItem>
              <input 
                type="checkbox"
                checked={isChecked} 
                onChange={() => handleToggle(el)}
              />
              </RowItem>
            <BasicFlex justify="flex-start" gap="5rem">
              <RowItem>{el.wig_id}</RowItem>
              <RowItem><SimpleChip label={el.sku} /></RowItem>
            </BasicFlex>
          </Row>
        )})}
      </Container>

      <InputLabel>Selected Wigs ({selectedWigs.length})</InputLabel>

      <SelectedTagsContainer>
        
        {selectedWigs.map((wig) => (
          <WigLine key={wig.wig_id}>
            <TaskAltRoundedIcon fontSize="small" color="success" />
            <WigLineInfo gap="2rem">
              <div>{wig.wig_id}</div>
              <SimpleChip label={wig.sku} />
            </WigLineInfo>
            <IconButton 
              onClick={() => handleToggle(wig)}
              title="Remove item"
            >
              <CloseRounded fontSize="small" />
            </IconButton>
          </WigLine>
        ))}
      </SelectedTagsContainer>
    </BasicFlex>
  )
};

export default ReturnWigs;